// Utility functions for managing user stories in localStorage
// In the future, this will be replaced with backend API calls

export const saveStoryToMyStories = (storyData) => {
  try {
    // Get existing stories from localStorage
    const existingStories = getStoriesFromStorage();
    
    // Create a new story object
    const newStory = {
      id: generateStoryId(),
      title: generateStoryTitle(storyData),
      storyParts: storyData.story_parts || splitStoryIntoParts(storyData.story || ''),
      imageUrl: storyData.visuals?.[0]?.url || null,
      createdAt: new Date().toISOString(),
      originalData: storyData,
      storyRequest: storyData.request || null
    };
    
    // Add new story to the beginning of the array (most recent first)
    const updatedStories = [newStory, ...existingStories];
    
    // Limit to 50 stories to prevent localStorage from getting too large
    const limitedStories = updatedStories.slice(0, 50);
    
    // Save back to localStorage
    localStorage.setItem('userStories', JSON.stringify(limitedStories));
    
    console.log('✅ Story saved to My Stories:', newStory.title);
    return newStory;
    
  } catch (error) {
    console.error('❌ Error saving story to My Stories:', error);
    return null;
  }
};

export const getStoriesFromStorage = () => {
  try {
    const savedStories = localStorage.getItem('userStories');
    return savedStories ? JSON.parse(savedStories) : [];
  } catch (error) {
    console.error('❌ Error loading stories from storage:', error);
    return [];
  }
};

export const deleteStoryFromStorage = (storyId) => {
  try {
    const existingStories = getStoriesFromStorage();
    const updatedStories = existingStories.filter(story => story.id !== storyId);
    localStorage.setItem('userStories', JSON.stringify(updatedStories));
    return true;
  } catch (error) {
    console.error('❌ Error deleting story:', error);
    return false;
  }
};

export const clearAllStories = () => {
  try {
    localStorage.removeItem('userStories');
    return true;
  } catch (error) {
    console.error('❌ Error clearing stories:', error);
    return false;
  }
};

// Helper functions
const generateStoryId = () => {
  return `story_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

const generateStoryTitle = (storyData) => {
  // Try to extract a title from the story content
  const storyText = storyData.story || '';
  const firstPart = storyData.story_parts?.[0] || storyText;
  
  // Look for potential titles in the first part
  const sentences = firstPart.split(/[.!?]+/);
  const firstSentence = sentences[0]?.trim();
  
  if (firstSentence && firstSentence.length > 10 && firstSentence.length < 60) {
    // Clean up the sentence to make it a good title
    let title = firstSentence
      .replace(/^(In|Once|There|A long time ago|It was|One day)/i, '')
      .trim();
    
    // If we removed the beginning, make sure it starts properly
    if (title.length < firstSentence.length) {
      title = title.charAt(0).toUpperCase() + title.slice(1);
    }
    
    return title || generateGenericTitle();
  }
  
  return generateGenericTitle();
};

const generateGenericTitle = () => {
  const adjectives = ['Magical', 'Wonderful', 'Amazing', 'Enchanted', 'Mystical', 'Charming'];
  const nouns = ['Adventure', 'Tale', 'Story', 'Journey', 'Dream', 'Quest'];
  
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  
  return `A ${randomAdjective} ${randomNoun}`;
};

const splitStoryIntoParts = (storyText) => {
  if (!storyText) return [''];
  
  // Simple splitting into 4 parts
  const sentences = storyText.split(/[.!?]+/).filter(s => s.trim());
  const partSize = Math.ceil(sentences.length / 4);
  const parts = [];
  
  for (let i = 0; i < 4; i++) {
    const start = i * partSize;
    const end = start + partSize;
    const partSentences = sentences.slice(start, end);
    
    if (partSentences.length > 0) {
      let part = partSentences.join('. ').trim();
      if (part && !part.endsWith('.') && !part.endsWith('!') && !part.endsWith('?')) {
        part += '.';
      }
      parts.push(part);
    }
  }
  
  return parts;
};